// extracted by mini-css-extract-plugin
export default {"time":"time___Y_QcN","isOver":"isOver___SyzeJ"};